import RiskManagement from './RiskManagement';

export default RiskManagement;
